"use client";

import { createContext, useContext } from "react";
import type { SettingsType } from "@/src/lib/settings";

const SettingsContext = createContext<SettingsType | null>(null);

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
};

export const SettingsProvider = ({
  children,
  settings,
}: {
  children: React.ReactNode;
  settings: SettingsType;
}) => {
  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
};
